export default {
    LOAD_REPORT_PRODUCTS(state, report_products) {
        state.items = report_products;
    }
}